import { useUncontrolledProp } from 'uncontrollable';
/**
 * Хук для работы с состоянием.
 * Нужен для поддержки controlled/uncontrolled поведения, в зависимости от того были ли переданы входные аргументы
 */
export function useValueControl({ value, onChange, defaultValue }) {
    return useUncontrolledProp(value, defaultValue, (newValue) => {
        const newState = typeof newValue === 'function' ? newValue(value) : newValue;
        onChange === null || onChange === void 0 ? void 0 : onChange(newState);
    });
}
